"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveContractsIgnoreWindow = void 0;
const dayjs = require("dayjs");
const getActiveContractsIgnoreWindow = (date, contracts) => {
    if (!contracts)
        return [];
    const activeContracts = contracts
        .filter((contract) => {
        if (!contract.start_date || !contract.end_date) {
            return false;
        }
        const endDate = new Date(contract.end_date).setUTCHours(0, 0, 0, 0);
        const startDate = new Date(contract.start_date).setUTCHours(0, 0, 0, 0);
        const currentDate = date
            ? dayjs(date, "YYYY-MM-DD").toDate().setUTCHours(0, 0, 0, 0)
            : new Date().setUTCHours(0, 0, 0, 0);
        // get all contracts where the current date is between the start and end date
        return currentDate >= startDate && currentDate <= endDate;
    })
        .sort((a, b) => {
        const aDate = new Date(a.start_date);
        const bDate = new Date(b.start_date);
        return aDate.getTime() - bDate.getTime();
    });
    return activeContracts;
};
exports.getActiveContractsIgnoreWindow = getActiveContractsIgnoreWindow;
